import { DateTime } from 'luxon';
import { FeriadosQuery_feriados } from '../../graphql/queries/__generated__/FeriadosQuery';

function mapear_feriados(feriados: FeriadosQuery_feriados[]) {
  const map = new Map<string, FeriadosQuery_feriados>();

  feriados.forEach((f) => {
    const chave = DateTime.fromISO(f.dat_feriado, { setZone: true }).startOf('day').toISODate();
    map.set(chave, f);
  });

  return map;
}

export { mapear_feriados };
